import * as React from "react";
import { ProductFrame, Section, TextCard, Text } from "../product/index.js";
export { ProductSample };

/**
 * Пример учебного продукта.
 * @returns {JSX.Element} Элемент JSX.
 */
function ProductSample() {
  return (
    <ProductFrame title="Устный экзамен">
      <Section icon="video" title="Видео-файл ответ">
        <TextCard type="primary">
          <h3>Продукт</h3>
          <dl>
            <dt>Дисциплина</dt>
            <dd>Таможенное право</dd>

            <dt>
              Подготовил<Text type="mute">(а)</Text>
            </dt>
            <dd>Мария Михайловна</dd>

            <dt>Проблемно-ориентированный вопрос</dt>
            <dd>
              Подготовьте ответ, в котором определите место,
              время и правила таможенного оформления
            </dd>
          </dl>
          <h3>Статус работы</h3>
          <p><Text type="primary">Идентификация</Text></p>
        </TextCard>
      </Section>
    </ProductFrame>
  );
}

/**
 * Название примера для SampleRouter.
 * @private
 */
ProductSample.title = "Учебный продукт";
